import Banner from './src/Banner';
export default Banner;